import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {ButtonComponent} from "../button/button.component";
import {ModalRef} from "../../services/modal.service";

@Component({
    selector: 'app-success-modal',
    imports: [
        ButtonComponent,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './success-modal.component.html'
})
export class SuccessModalComponent {
  readonly modalRef: ModalRef<SuccessModalComponent> = inject<ModalRef<SuccessModalComponent>>(ModalRef);
}
